module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pages":"Pages","pages_placeholder":"Add pages.."},"fr":{"pages":"Pages","pages_placeholder":"Ajouter des pages.."},"de":{"pages":"Seiten","pages_placeholder":"Seiten hinzufügen..."}}')
  delete Component.options._Ctor
}
